export * from './vpc.read.service';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/amazon/src/vpc/index.ts